import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";
import { LEAType } from "./events";

export interface LeaReportResponse {
  fir_number: string;
  lea_main_address: string;
  lea_status_detailed?: string | null;
}

export interface LeaReportsData {
  [LEAType.CBI]?: LeaReportResponse;
  [LEAType.STATE_POLICE]?: LeaReportResponse;
  [LEAType.CYBER_POLICE]?: LeaReportResponse;
}

export interface LEASubmissionsResponse {
  lea_submissions?: LeaReportsData | null;
}

export interface LeaSubmissionMessageResponse {
  message: string;
}

export const LeaReportsAPI = {
  getLeaReports: async (case_id: string): Promise<LEASubmissionsResponse> => {
    const response: AxiosResponse<LEASubmissionsResponse> =
      await axiosInstance.get(`/v1/cases/${case_id}/lea-reports`);
    return response.data;
  },

  upsertLeaReports: async (
    case_id: string,
    request: LeaReportsData
  ): Promise<LeaSubmissionMessageResponse> => {
    const response: AxiosResponse<LeaSubmissionMessageResponse> =
      await axiosInstance.put(`/v1/cases/${case_id}/lea-reports`, request);
    return response.data;
  },
};

